module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-sm-7452693b.svg";